export const  DateTimeFormat=(createdTime)=>{
    const date = new Date(createdTime);

  // Format the date to the desired format
  const formattedDate = date.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
  return formattedDate;
}

export const  DateFormat=(createdTime)=>{
    const date = new Date(createdTime);

    // Get the year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
  return year+'-'+month+'-'+day;
}

export const  YearMonthDateFormat=(createdTime)=>{
    const date = new Date(createdTime);

    // Get the year, month, and day
    const year = date.getFullYear();
    const month = (date.getMonth() + 1)<10?'0'+(date.getMonth() + 1):(date.getMonth() + 1); // Months are 0-indexed
    const day = date.getDate();
  return year+'-'+month+'-'+day;
}

export const convertDateTime=(date_time_string,timezone)=>{
  const convertedDatetimeString = date_time_string.replace(' ', 'T');
const date_time = new Date(convertedDatetimeString);
const formatted_date_time = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: timezone
}).format(date_time);

return formatted_date_time;

}

export const convertTime=(date_time_string,timezone)=>{
  const convertedDatetimeString = date_time_string.replace(' ', 'T');
  const date_time = new Date(convertedDatetimeString);
  const formatted_time = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: timezone
  }).format(date_time);
  
  return formatted_time;
  
  }

  export const convertTimeWithoutTimezone=(date_time_string)=>{
    const convertedDatetimeString = date_time_string.replace(' ', 'T');
  const date_time = new Date(convertedDatetimeString);
  const formatted_date_time = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
  }).format(date_time);
  
  return formatted_date_time;
  
  }
// Public teacher profile URL, e.g. /teacher/m-hasan-riad-30 (falls back to the id).
export const teacherPath = (teacher, prefix = '') => `${prefix}/teacher/${teacher?.slug || teacher?.id}`;

export const flagUrl = (code) => code ? `https://flagcdn.com/w40/${code.toLowerCase()}.png` : null;
